import { useEffect, useState } from "react";
import globals from "../../../globals";
import { useAuth } from "../../Context/store/context";
import { _get } from "../../../apiClient";
import { useSelector } from "react-redux";
import Addon from "./Addon";
import CheckoutPopup from "../Checkout/CheckoutPopup";
import { loadRazorpayScript, createOrder, processPayment } from "../Checkout/MakePayment";
import { _showToast } from "../../../toastHelper";
import { useNavigate } from "react-router-dom";

export default function Addons() {

    const { logoutuser, showLoader, hideLoader, getToken, updateTitleAndIcon } = useAuth();
    const userDetails = useSelector((state) => state.admininfo.admininfo);
    const [addons, setAddons] = useState([]);
    const [showCheckout, setShowCheckout] = useState(false);
    const [selectedAddon, setSelectedAddon] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (!getToken())
            logoutuser();
        updateTitleAndIcon(globals.addons.title, globals.addons.icon);
    }, []);

    useEffect(() => {
        if (userDetails) {
            getAddons();
        }
    }, [userDetails]);

    const getAddons = async () => {
        showLoader();
        await _get(`/packages/AddOn`)
            .then(response => {
                setAddons(response);
                hideLoader();
            }).catch(error => {
                _showToast(error, "error");
                hideLoader();
            });
    }

    const addOnSelectHandler = async (addon) => {
        setSelectedAddon(addon);
        setShowCheckout(true);
    }

    const closeCheckoutHanlder = async () => {
        setShowCheckout(false);
        setSelectedAddon(null);
    }

    const proceedToPaymentHandler = async (addon, quantity) => {
        setShowCheckout(false);
        showLoader();
        let response = await createOrder(userDetails.id, addon.id, quantity);

        if (response != 'failed') {
            if (response == "Success") {
                hideLoader();
                _showToast("Thanks! You’re Registered for the Package.", "success");
            }
            else {
                await makePayment(userDetails, response);
            }
        }

        hideLoader();
    }

    const makePayment = async (userdetails, orderId) => {
        const scriptLoaded = await loadRazorpayScript(
            "https://checkout.razorpay.com/v1/checkout.js"
        );

        if (!scriptLoaded) {
            _showToast("Razorpay SDK failed to load. Are you online?", "info");
            return;
        }

        var options = {
            currency: "INR",
            order_id: orderId,
            handler: async function (response) {
                showLoader("Please do not close the browser or refresh the page. We are currently processing your payment. This may take a moment.");
                let status = await processPayment(response);
                hideLoader();
                if (status) {
                    _showToast("Thanks! You’re Registered for the Package.", "success");
                    navigate("/plans")
                }
            },
            prefill: {
                name: userdetails.firstName + " " + userdetails.lastName,
                email: userdetails.email,
                contact: userdetails.contactNo,
            }
        };

        var rzp1 = new window.Razorpay(options);
        rzp1.on("payment.failed", function (response) {
            _showToast(response.error.description, "info");
        });
        rzp1.open();
    };

    return (
        <>
            <div className="content-wrapper">
                <div className="container-xxl flex-grow-1 container-p-y">
                    <div className="d-flex flex-column gap-0 mp-2 rounded justify-content-center align-items-center">
                        <div className="w-100 mb-4">
                            <div className="w-100 gap-4 gap-md-0 justify-content-start mb-3 row">
                                {addons?.map((addon) => {
                                    return <Addon data={addon} key={addon.id} onAddonSelect={addOnSelectHandler} />
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                showCheckout && (<CheckoutPopup addon={selectedAddon} onClose={closeCheckoutHanlder} onPayment={proceedToPaymentHandler} />)
            }
        </>
    )
}